import React from 'react'
import './skeleton.css'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  borderRadius?: string | number
  className?: string
}

// Base skeleton component
export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '1rem',
  borderRadius = '0.25rem',
  className = '',
}) => (
  <div
    className={`skeleton ${className}`}
    style={{
      width,
      height,
      borderRadius,
    }}
  />
)

// Skeleton for source cards in the grid
export const SkeletonSourceCard: React.FC = () => (
  <div className="skeleton-source-card">
    <div className="skeleton-card-header">
      <Skeleton width="2rem" height="2rem" borderRadius="50%" />
      <div className="skeleton-title-section">
        <Skeleton width="70%" height="1.25rem" />
        <Skeleton width="50%" height="0.875rem" />
      </div>
      <Skeleton width="2rem" height="2rem" borderRadius="50%" />
    </div>
    <div className="skeleton-card-body">
      <Skeleton width="100%" height="0.875rem" />
      <Skeleton width="80%" height="0.875rem" />
    </div>
    <div className="skeleton-card-footer">
      <Skeleton width="4rem" height="1.5rem" borderRadius="0.75rem" />
      <Skeleton width="3rem" height="1.5rem" borderRadius="0.75rem" />
      <Skeleton width="5rem" height="1.5rem" borderRadius="0.75rem" />
    </div>
  </div>
)

// Skeleton for filter sections
export const SkeletonFilterSection: React.FC = () => (
  <div className="skeleton-filter-section">
    <div className="skeleton-filter-header">
      <Skeleton width="60%" height="1rem" />
      <Skeleton width="1rem" height="1rem" />
    </div>
    <div className="skeleton-filter-options">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="skeleton-filter-option">
          <Skeleton width="1rem" height="1rem" />
          <Skeleton width="70%" height="0.875rem" />
          <Skeleton width="2rem" height="0.875rem" />
        </div>
      ))}
    </div>
  </div>
)

// Skeleton for search bar
export const SkeletonSearchBar: React.FC = () => (
  <div className="skeleton-search-bar">
    <div className="skeleton-search-input">
      <Skeleton width="2rem" height="2rem" />
      <Skeleton width="100%" height="1.5rem" />
    </div>
    <Skeleton width="6rem" height="2.5rem" borderRadius="0.375rem" />
  </div>
)

// Skeleton for the entire source grid
export const SkeletonSourceGrid: React.FC<{ count?: number }> = ({ count = 6 }) => (
  <div className="skeleton-source-grid">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonSourceCard key={i} />
    ))}
  </div>
)

// Skeleton for filter sidebar
export const SkeletonFilterSidebar: React.FC = () => (
  <div className="skeleton-filter-sidebar">
    <SkeletonFilterSection />
    <SkeletonFilterSection />
    <SkeletonFilterSection />
  </div>
)
